export default __webpack_public_path__ + "static/Poppins-BlackHeavy-af8417016b92be8a41e78937b750c52c.woff2";